import { render } from "./GrossSalesCategorySplit.vue?vue&type=template&id=0fb088f3"
import script from "./GrossSalesCategorySplit.vue?vue&type=script&lang=js"
export * from "./GrossSalesCategorySplit.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./GrossSalesCategorySplit.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_229a35a3%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fanalytics%2Fretail%2Fbreakdown%2FGrossSalesCategorySplit.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__